import Proxies from 'Components/proxies'
import {
  fetchSuppliersRequest,
  fetchSuppliersFailed,
  fetchSuppliersSuccess,
  fetchSupplierDetailsRequest,
  fetchSupplierDetailsFailed,
  fetchSupplierDetailsSuccess,
  supplierCreationSuccess,
  supplierCreationFailure,
  isSavingSupplier,
  removeSupplierFailure,
  removeSupplierSuccess,
  updateSupplierAccess,
  removeSupplierAccess,
  updateFreightInterval,
  removeFreightInterval,
  fetchCarriersSuccess
} from 'Reducers/supplierReducer'
import keyMirror from 'keymirror'

export const STATUS = keyMirror({
  FETCHING_SUPPLIERS: null,
  FETCHING_SUPPLIERS_SUCCESS: null,
  FETCHING_SUPPLIERS_FAILED: null,
  FETCHING_SUPPLIER_DETAILS: null,
  FETCHING_SUPPLIER_DETAILS_FAILED: null,
  FETCHING_SUPPLIER_DETAILS_SUCCESS: null,
  SUPPLIER_SUCCESS: null,
  SUPPLIER_FAILED: null,
  IS_SAVING: null,
  IS_REDIRECT: null,
  DELETE_SUPPLIER_FAILED: null,
  DELETE_SUPPLIER_SUCCESS: null
})

export const getSuppliers = data => dispatch => {
  dispatch(fetchSuppliersRequest())
  Proxies.GET('suppliers/pool', data).then(responseJSON => {
    if (responseJSON && responseJSON.error) {
      dispatch(fetchSuppliersFailed())
    } else {
      dispatch(fetchSuppliersSuccess(responseJSON))
    }
  })
}

export const getSupplierDetails = SupplierID => dispatch => {
  dispatch(fetchSupplierDetailsRequest())
  Proxies.GET('suppliers/fetch', { SupplierID }).then(responseJSON => {
    if (responseJSON && responseJSON.error) {
      dispatch(fetchSupplierDetailsFailed())
    } else {
      responseJSON.freightIntervals = responseJSON.freightIntervals.sort((a, b) => a.minWeight - b.minWeight)
      dispatch(fetchSupplierDetailsSuccess(responseJSON))
    }
  })
}

export const saveSupplier = data => dispatch => {
  dispatch(isSavingSupplier())
  Proxies.POST('suppliers/replace', { ...data }).then(responseJSON => {
    if (responseJSON && responseJSON.error) {
      dispatch(supplierCreationFailure())
    } else {
      dispatch(supplierCreationSuccess(responseJSON))
    }
  })
}

export const deleteSupplier = data => dispatch => {
  dispatch(isSavingSupplier())
  Proxies.POST('suppliers/removeSupplier', data).then(responseJSON => {
    if (responseJSON && responseJSON.error) {
      dispatch(removeSupplierFailure())
    } else {
      dispatch(removeSupplierSuccess())
    }
  })
}

export const updateAccess = data => dispatch => {
  dispatch(updateSupplierAccess(data))
}

export const deleteSupplierAccess = data => dispatch => {
  dispatch(removeSupplierAccess(data))
}

export const updateInterval = data => dispatch => {
  dispatch(updateFreightInterval(data))
}

export const deleteInterval = data => dispatch => {
  dispatch(removeFreightInterval(data))
}

export const getCarriers = data => dispatch => {
  dispatch(fetchSuppliersRequest())
  Proxies.GET('carriers/pool', data).then(responseJSON => {
    if (responseJSON && !responseJSON.error) {
      dispatch(fetchCarriersSuccess(responseJSON))
    }
  })
}
